import { Box } from "@mui/material";
import PageTopBar from "../../../components/common/PageTopBar";
import { FeeReport } from "../../../modules/common/components/Fee/FeeReport";
import { UserRole } from "../../../modules/common/shared/types";
import { getLoggedInUserRole } from "../../../modules/common/user/UserService";
import { StudentFeeReceipts } from "../components/StudentFeeReceipts";


export const FeeReceiptsC = () => {
  const role = getLoggedInUserRole();
  if (role === UserRole.ADMIN)
    return <FeeReport />
  // Student: their own receipts, no filters
  if (role === UserRole.STUDENT)
    return (
      <Box sx={{ mt: 2, mr: 2 }}>
        <PageTopBar left="Receipts" />
        <StudentFeeReceipts />
      </Box>
    );

}
